export default __webpack_public_path__ + "static/Whatsapp-e1f80f3dcce42321b79527748fe1613b.svg";